import { stateNames } from './locationInfo';

// Set up data for climateAttrs
const startYear = 1981;
const endYear = new Date().getFullYear();
const currMonth = new Date().getMonth();
const params = {
  sdate: startYear,
  edate: endYear,
  grid: 'prism',
  state: stateNames,
};

// Object used in many parts of the program
// To add, edit, or remove attribute options for the tool just change this object
// Be sure to also alter the themeGroupings above with any changes

// IDs 1000-1999 will be interpretted as options within the app
// IDs 3000-3999 will be interpretted as external links and will require a url. When selected they open a new tab but do not change any app state
export const climateAttrs = [
  {
    id: 1000,
    
    name: 'Summer Maximum Temperature',
    fileName: 'summer_maximum_temperature.json.gzip',
    themes: [6],
    units: '°F',
    text: 'maximum temperatures ',
    precip: false,
    isReversed: false,
    winter: false,
    title: 'Average Summer Maximum Temperature',
    month: '-08',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-08`,
      edate: `${currMonth < 8 ? endYear - 1 : endYear}-08`,
      elems: [
        {
          name: 'maxt',
          interval: [1, 0],
          duration: 3,
          reduce: 'mean',
        },
      ],
    },
  },
  {
    id: 1001,
    fileName: 'winter_minimum_temperature.json.gzip',
    name: 'Winter Minimum Temperature',
    themes: [8],
    units: '°F',
    text: 'minimum temperatures ',
    precip: false,
    isReversed: false,
    winter: true,
    title: 'Average Winter Minimum Temperature',
    month: '-02',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-02`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-02`,
      elems: [
        {
          name: 'mint',
          interval: [1, 0],
          duration: 3,
          reduce: 'mean',
        },
      ],
    },
  },
  {
    id: 1002,
    fileName: 'days_with_maxt_over_90.json.gzip',
    name: 'Days w/ High >90°F',
    themes: [6],
    units: ' days',
    text: 'number of days with high temperatures over 90°F ',
    precip: false,
    isReversed: false,
    winter: false,
    title: 'Number of Days with Maximum Temperature Over 90°F',
    month: '',
    dayUnits: true,
    params: {
      ...params,
      elems: [
        {
          name: 'maxt',
          interval: [1],
          duration: 1,
          reduce: 'cnt_gt_90',
        },
      ],
    },
  },
  {
    id: 1003,
    fileName: 'days_with_maxt_over_95.json.gzip',
    name: 'Days w/ High >95°F',
    themes: [6],
    units: ' days',
    text: 'number of days with high temperatures over 95°F ',
    precip: false,
    isReversed: false,
    winter: false,
    title: 'Number of Days with Maximum Temperature Over 95°F',
    month: '',
    dayUnits: true,
    params: {
      ...params,
      elems: [
        {
          name: 'maxt',
          interval: [1],
          duration: 1,
          reduce: 'cnt_gt_95',
        },
      ],
    },
  },
  {
    id: 1004,
    fileName: 'days_with_maxt_over_100.json.gzip',
    name: 'Days w/ High >100°F',
    themes: [6],
    units: ' days',
    text: 'number of days with high temperatures over 100°F ',
    precip: false,
    isReversed: false,
    winter: false,
    title: 'Number of Days with Maximum Temperature Over 100°F',
    month: '',
    dayUnits: true,
    params: {
      ...params,
      elems: [
        {
          name: 'maxt',
          interval: [1],
          duration: 1,
          reduce: 'cnt_gt_100',
        },
      ],
    },
  },
  {
    id: 1005,
    fileName: 'days_with_mint_under_0.json.gzip',
    name: 'Days w/ Low <0°F',
    themes: [8],
    units: ' days',
    text: 'number of days with low temperatures under 0°F ',
    precip: false,
    isReversed: true,
    winter: true,
    title: 'Number of Days with Minimum Temperature Below 0°F',
    month: '-07',
    dayUnits: true,
    params: {
      ...params,
      sdate: `${startYear}-07`,
      edate: `${currMonth < 7 ? endYear - 1 : endYear}-07`,
      elems: [
        {
          name: 'mint',
          interval: [1, 0],
          duration: 12,
          reduce: 'cnt_lt_0',
        },
      ],
    },
  },
  {
    id: 1006,
    fileName: 'days_with_maxt_under_32.json.gzip',
    name: 'Days w/ High <32°F',
    themes: [8],
    units: ' days',
    text: 'number of days with high temperatures under 32°F ',
    precip: false,
    isReversed: true,
    winter: true,
    title: 'Number of Days with Maximum Temperature Below 32°F',
    month: '-07',
    dayUnits: true,
    params: {
      ...params,
      sdate: `${startYear}-07`,
      edate: `${currMonth < 7 ? endYear - 1 : endYear}-07`,
      elems: [
        {
          name: 'maxt',
          interval: [1, 0],
          duration: 12,
          reduce: 'cnt_lt_32',
        },
      ],
    },
  },
  {
    id: 1007,
    fileName: 'total_spring_precipitation.json.gzip',
    name: 'Total Spring Precipitation',
    themes: [1],
    units: ' inches',
    text: 'total spring precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Total Spring Precipitation',
    month: '-05',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-05`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-05`,
      elems: [
        {
          name: 'pcpn',
          interval: [1, 0],
          duration: 3,
          reduce: 'sum',
        },
      ],
    },
  },
  {
    id: 1008,
    fileName: 'total_summer_precipitation.json.gzip',
    name: 'Total Summer Precipitation',
    themes: [1],
    units: ' inches',
    text: 'total summer precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Total Summer Precipitation',
    month: '-08',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-08`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-08`,
      elems: [
        {
          name: 'pcpn',
          interval: [1, 0],
          duration: 3,
          reduce: 'sum',
        },
      ],
    },
  },
  {
    id: 1009,
    fileName: 'total_fall_precipitation.json.gzip',
    name: 'Total Fall Precipitation',
    themes: [1],
    units: ' inches',
    text: 'total fall precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Total Fall Precipitation',
    month: '-11',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-11`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-11`,
      elems: [
        {
          name: 'pcpn',
          interval: [1, 0],
          duration: 3,
          reduce: 'sum',
        },
      ],
    },
  },
  {
    id: 1010,
    fileName: 'total_winter_precipitation.json.gzip',
    name: 'Total Winter Precipitation',
    themes: [1],
    units: ' inches',
    text: 'total winter precipitation ',
    precip: true,
    isReversed: false,
    winter: true,
    title: 'Total Winter Precipitation',
    month: '-02',
    dayUnits: false,
    params: {
      ...params,
      sdate: `${startYear}-02`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-02`,
      elems: [
        {
          name: 'pcpn',
          interval: [1, 0],
          duration: 3,
          reduce: 'sum',
        },
      ],
    },
  },
  {
    id: 1011,
    fileName: 'total_annual_precipitation.json.gzip',
    name: 'Total Annual Precipitation',
    themes: [1],
    units: ' inches',
    text: 'total annual precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Total Annual Precipitation',
    month: '',
    dayUnits: false,
    params: {
      ...params,
      elems: [
        {
          name: 'pcpn',
          interval: [1],
          duration: 1,
          reduce: 'sum',
        },
      ],
    },
  },
  {
    id: 1012,
    fileName: 'days_with_pcpn_over_1.json.gzip',
    name: 'Days w/ Pcpn >1in',
    themes: [1],
    units: ' days',
    text: 'number of days with more than 1 inch of precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Number of Days with Precipitation >1 Inches',
    month: '',
    dayUnits: true,
    params: {
      ...params,
      elems: [
        {
          name: 'pcpn',
          interval: [1],
          duration: 1,
          reduce: 'cnt_gt_1',
        },
      ],
    },
  },
  {
    id: 1013,
    fileName: 'days_with_pcpn_over_2.json.gzip',
    name: 'Days w/ Pcpn >2in',
    themes: [1],
    units: ' days',
    text: 'number of days with more than 2 inch of precipitation ',
    precip: true,
    isReversed: false,
    winter: false,
    title: 'Number of Days with Precipitation >2 Inches',
    month: '',
    dayUnits: true,
    params: {
      ...params,
      elems: [
        {
          name: 'pcpn',
          interval: [1],
          duration: 1,
          reduce: 'cnt_gt_2',
        },
      ],
    },
  }
];

export const selectClimateAttrById = (id) => {
  return climateAttrs.find((attr) => attr.id === id);
};
